import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const constantRoutes = [
  // {
  //   path: '/login',
  //   name: 'login',
  //   meta: {
  //     title: '登录',
  //     requiresAuth: false
  //   },
  //   component: () => import('@/views/login/Login.vue')
  // },
  // {
  //   path: '/',
  //   name: 'home',
  //   meta: {
  //     title: '首页',
  //     requiresAuth: true
  //   },
  //   component: () => import('@/views/home/Home.vue')
  // },
  {
    path: "/",
    name: "encyclopedias",
    component: () => import("@/views/home/Encyclopedias.vue"),
  },
  {
    path: "/entrylist/:search?",
    name: "entryList",
    component: () => import("@/views/home/EntrySearchList.vue"),
  },
  {
    path: "/entryitem/:search?",
    name: "entryItem",
    component: () => import("@/views/home/EntryItem.vue"),
  },
  {
    path: "/articleitem/:id?",
    name: "articleItem",
    component: () => import("@/views/home/ArticleItem.vue"),
  },
  {
    path: "/menuslist",
    name: "menuslist",
    component: () => import("@/views/home/MenusList.vue"),
  },
  {
    path: "/entrylists",
    name: "entrylists",
    component: () => import("@/views/home/EntryList.vue"),
  },
  {
    path: "/extendlist",
    name: "extendlist",
    component: () => import("@/views/home/ExtendList.vue"),
  },
  {
    // 今日排行榜
    path: "/todaylist",
    name: "todaylist",
    component: () => import("@/views/home/TodaysList.vue"),
  },
  {
    // 排行榜列表
    path: "/todayListTable",
    name: "todayListTable",
    component: () => import("@/views/home/todayListTable.vue"),
  },
  {
    // 隧道视频
    path: "/tunnelvideo",
    name: "tunnelVideo",
    component: () => import("@/views/home/TunnelVideo.vue"),
  },

  //     H5
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/H5/index.vue"),
  },
  {
    path: "/m",
    name: 'tabBody',
    component: () => import("@/views/H5/tabBody/tabBody.vue"),
    children: [{
        // 词条分类总目
        path: "entrycategoryitemm",
        name: "entryCategoryItemm",
        component: () =>
          import("@/views/H5/entryCategoryItemm/entryCategoryItemm.vue"),
      },
      {
        // 扩展阅读
        path: 'extendlistm',
        name: 'extendListm',
        component: () => import('@/views/H5/extendList/extendList.vue')
      },
      {
        // 视频列表
        path: 'videolist',
        name: 'videoList',
        component: () => import('@/views/H5/videoList/videoList.vue')
      },
      {
        // 搜索结果
        path: "searchresult",
        name: "searchresult",
        component: () => import("@/views/H5/searchResult/searchResult.vue"),
      },
    ]
  },
  {
    // 词条总目
    path: "/entrylistm",
    name: "entryListm",
    component: () => import("@/views/H5/entryList/entryList.vue"),
  },
  {
    // 词条详情
    path: "/entrylistdetailm/:search?",
    name: "entryListDetailm",
    component: () => import("@/views/H5/entrylistdetailm/entrylistdetailm.vue"),
  },
  {
    // 文章详情
    path: "/articledetailm/:id?",
    name: "articleDetailm",
    component: () => import("@/views/H5/articleDetailm/articleDetailm.vue"),
  },

  {
    path: "/404",
    meta: {
      title: "404",
      requiresAuth: true,
    },
    hidden: true,
    component: () => import("@/views/404.vue"),
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];
// export function resetRouter() {
//   const newRouter = createRouter()
//   router.matcher = newRouter.matcher // reset router
// }
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;